import { Landmark } from "lucide-react";

import {
  IAR_DISCLAIMER,
  HTG_FINANCE_DISCLOSURE,
  SHOW_ZERO_PERCENT,
  ZERO_PERCENT_RISK_STATEMENT,
} from "@/content/finance";

const FULL_VARIANT_FOOTER =
  "Subject to status, property suitability and a credit agreement.";

const BOTH_VARIANT_FOOTER = "";

export type FinanceProvider = "i4f" | "hometree";

type FinanceProviderDisclosureProps = {
  variant?: "full" | "compact";
  /** Which providers are referenced on the page. Defaults to Ideal4Finance only. */
  providers?: readonly FinanceProvider[];
};

function DisclaimerCopy({
  className,
  providers,
}: {
  className?: string;
  providers: readonly FinanceProvider[];
}) {
  const showI4f = providers.includes("i4f");
  const showHometree = providers.includes("hometree");

  return (
    <>
      {showI4f && <p className={className}>{IAR_DISCLAIMER}</p>}
      {showHometree && <p className={className}>{HTG_FINANCE_DISCLOSURE}</p>}
      {SHOW_ZERO_PERCENT && (
        <p className={className}>{ZERO_PERCENT_RISK_STATEMENT}</p>
      )}
    </>
  );
}

export function FinanceProviderDisclosure({
  variant = "full",
  providers = ["i4f"],
}: FinanceProviderDisclosureProps) {
  const footer = providers.includes("hometree")
    ? BOTH_VARIANT_FOOTER
    : FULL_VARIANT_FOOTER;

  if (variant === "compact") {
    return (
      <div className="text-[11px] leading-relaxed text-muted-foreground/90 space-y-2">
        <DisclaimerCopy providers={providers} />
      </div>
    );
  }

  return (
    <section className="bg-secondary/40 py-10 md:py-12">
      <div className="container-page max-w-4xl">
        <div className="rounded-2xl border border-border bg-card p-6 md:p-8">
          <div className="flex items-start gap-3 mb-3">
            <Landmark className="h-5 w-5 text-primary shrink-0" aria-hidden />
            <p className="text-sm uppercase font-bold tracking-wider text-primary">
              Regulatory Disclosure
            </p>
          </div>

          <div className="space-y-4 mb-5">
            <DisclaimerCopy
              className="text-base text-foreground leading-relaxed"
              providers={providers}
            />
          </div>

          {footer ? (
            <p className="text-base text-foreground/90 leading-relaxed">
              {footer}
            </p>
          ) : null}
        </div>
      </div>
    </section>
  );
}
